<template>
  <div class="app-container" :style="{
      background: `url('${processedCityOption.backgroundImage}') no-repeat`,
      'background-size': '100% 100%',
    }">
    <div class="title">
      <span class="titleText">{{ processedCityOption.cityName
        }}{{
        processedCityOption.homeTitle
        ? processedCityOption.homeTitle
        : "农村集体“三资”监督管理平台"
        }}
      </span>
    </div>

    <div style="flex: 0.2"></div>
    <div class="tapList" :style="{ width: widthSize[linkList.length] + 'px' }">
      <div v-for="(item, index) in linkList" :key="index" @click="toChild(item)" class="tapItem" :style="{
          background: `url(${item.backGround})`,
          'background-repeat': 'no-repeat',
          margin: `40px ${marginSize[linkList.length]}`,
          'line-height': 'auto',
          'background-size': '100% 100%',
        }">
        <img :src="item.src" alt="" />
        <span :style="{ 'font-size': '22px' }">{{ item.name }}</span>
      </div>
    </div>
    <div class="linkList" v-if="!processedCityOption.notShowCqjyDetail">
      <div @click="showDialog(0)">
        <img src="@/assets/images/zcfg.png" alt="" />
        <span>政策法规</span>
      </div>
      <div @click="showDialog(1)">
        <img src="@/assets/images/zlxz.png" alt="" />
        <span>资料下载</span>
      </div>
      <div @click="showDialog(2)">
        <img src="@/assets/images/zdgz.png" alt="" />
        <span>规章制度</span>
      </div>
    </div>
    <div style="flex: 1"></div>

    <div class="footerHome" v-if="!processedCityOption.footList">
      <div class="footerHomeDiv">
        <span>主管部门:</span>
        <span>{{ processedCityOption.cityName }}农业农村局</span>
      </div>
      <div class="footerHomeDiv">
        <span>监督部门:</span>
        <span>{{ processedCityOption.cityName }}纪委监委</span>
      </div>
      <div class="footerHomeDiv">
        <span>技术单位:</span>
        <span>河南晟宇信息技术有限公司</span>
      </div>
    </div>
    <div class="footerHome" v-else>
      <div class="footerHomeDiv" v-for="(foot, index) in processedCityOption.footList" :key="index">
        <span>{{ foot.text }}</span>
      </div>
    </div>
    <el-dialog width="70%" :title="dialogTitle" :visible.sync="open">
      <el-dialog width="60%" :title="dialogTitle + '详情'" :visible.sync="showDetail" append-to-body
        class="detail_dialog">
        <h2 style="text-align: center">{{ newsDetail.title }}</h2>
        <div style="display: flex; align-items: center; justify-content: center">
          <span>信息来源：{{ newsDetail.source }}</span>
          <span>信息时间：{{ newsDetail.logintime }}</span>
        </div>
        <div v-html="newsDetail.content"></div>
      </el-dialog>
      <el-table :data="dataList" :border="true" max-height="600px">
        <el-table-column prop="title" label="标题" show-overflow-tooltip header-align="center"></el-table-column>
        <el-table-column property="source" label="信息来源" align="center">
        </el-table-column>
        <el-table-column property="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column align="center" property="address" label="操作">
          <template slot-scope="scope">
            <el-button @click="selectDetail(scope.row)" type="primary" size="mini">查 看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <div class="appImage" v-if="processedCityOption.showAppImage && processedCityOption.appImage">
      <div class="phoneIcon">
        <i class="el-icon-mobile-phone"></i>
        <span>福农通App</span>
        <div class="image">
          <img :src="processedCityOption.appImage" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getNewsList } from '@/api/产权交易'
  import { processConfigImages, getImageUrl } from '@/util/imageLoader'
  export default {
    name: "Index",
    components: {},
    data() {
      return {
        open: false,
        showDetail: false,
        dataList: [],
        dialogTitle: "",
        newsDetail: "",
        widthSize: {
          9: "1052",
          8: "940",
          6: "1200"
        },
        marginSize: {
          9: "30px",
          8: "30px",
          6: "80px"
        },
        linkList: [],
        processedCityOption: {}
      }
    },
    created() {
      // 处理cityOption中的图片路径
      this.processedCityOption = processConfigImages($config)
      // 处理全局$config中的linkList
      this.linkList = processConfigImages($config).linkList || []
    },
    watch: {
    },
    mounted() {
    },
    methods: {
      selectDetail(row) {
        this.showDetail = true
        this.newsDetail = row
      },
      async showDialog(typeIndex) {
        // await this.getList(num)
        // this.dialogTitle = title
        // this.open = true
        this.$router.push({
          path: "/news",
          query: {
            typeIndex: typeIndex
          }
        })
      },
      notGo() {
        this.$message({
          message: '正在更新中',
          type: 'warning'
        })
      },
      toChild({ url, notGo }) {
        if (notGo) {
          this.$message({
            message: '正在更新中',
            type: 'warning'
          })
          return
        }
        if (url) {
          window.open(url)
        }
      }
    },
  }
</script>
<style>
  .el-dialog__body {
    padding-top: 10px !important;
  }

  .detail_dialog .el-dialog {
    margin-top: 5vh !important;
    max-height: 88vh;
    overflow: auto;
  }

  #app {
    width: 100vw;
    height: 100vh;
  }
</style>
<style lang="scss" scoped>
  .app-container {
    /* background-color: red; */
    width: 100vw;
    height: 100vh;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding-bottom: 44px;
    display: flex;
    flex-flow: column nowrap;

    .title {
      width: 100%;
      height: auto;
      padding-top: 130px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;

      .titleText {
        font-family: Source Han Sans;
        font-size: 56px;
        font-weight: bold;
        line-height: normal;
        color: #ffffff;
        height: 80px;
        text-shadow: 1px 1px 1px #919191, 1px 2px 1px #919191, 1px 3px 1px #919191,
          1px 4px 1px #919191, 1px 5px 1px #919191,
          1px 18px 6px rgba(10, 10, 10, 0.4), 1px 22px 10px rgba(10, 10, 10, 0.2),
          1px 25px 35px rgba(10, 10, 10, 0.2), 1px 30px 60px rgba(10, 10, 10, 0.4);
        letter-spacing: 10px;
      }
    }

    .tapList {
      max-height: 348px;
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      margin: 0 auto;

      .tapItem:hover {
        transform: scale(1.2);
      }

      .tapItem {
        box-sizing: border-box;
        width: 180px;
        height: 180px;
        border-radius: 10px;
        opacity: 1;
        cursor: pointer;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
        overflow: hidden;
        margin-bottom: 30px;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;

        /* &:nth-child(7) {
        margin-left: 134px; 
        margin-left: 150px;
        margin-bottom: 28px;
      }*/

        &:nth-child(11) {
          /* margin-right: 134px; */
          margin-right: 119px;
          margin-bottom: 28px;
        }

        img {
          width: 80px;
          height: 80px;
          margin: 16px 0 8px 0;
          border-radius: 10px;
        }

        span {
          text-align: center;
          font-family: SourceHanSansSC;
          font-weight: bold;
          color: #191a1c;
          margin-top: 16px;
        }
      }
    }

    .linkList {
      display: flex;
      align-items: center;
      width: 400px;
      justify-content: space-around;
      margin: 0 auto;
      margin-top: 50px;

      div:hover {
        transform: scale(1.2);
      }

      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
          width: 90px;
          height: 90px;
          margin-bottom: 6px;
        }

        span {
          color: #fff;
          font-size: 18px;
        }
      }
    }

    .footerHome {
      width: 100%;
      height: 44px;
      /* background-color: rgba($color: #000000, $alpha: 0.3); */
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      position: fixed;
      left: 0;
      bottom: 0;

      color: #e0fffa;
      font-family: Source Han Sans;
      opacity: 1;
      font-size: 16px;
      font-weight: normal;

      .footerHomeDiv {
        padding: 0 52px;
        position: relative;

        span {
          &:first-child {
            margin-right: 8px;
          }
        }

        &::after {
          content: "|";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }

        &:last-child::after {
          display: none;
        }
      }

      .line {
        color: #93e5d9;
      }
    }

    .show-footer {
      /* 这里可以添加Footer显示时的其他样式 */
      opacity: 1;
      /* 或者使用其他方式显示Footer */
    }

    .close-footer {
      opacity: 0;
    }
  }

  .appImage {
    position: fixed;
    right: 30px;
    top: 70%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 100;

    .phoneIcon {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      background-color: #409eff;
      padding: 8px;
      box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
      border-radius: 8px;
      position: relative;

      i {
        color: #fff;
        font-size: 22px;
      }

      span {
        color: #fff;
        font-size: 14px;
        margin-top: 4px;
      }

      .image {
        position: absolute;
        right: 50%;
        bottom: calc(100% + 10px);
        transform: translateX(50%);
        width: 120px;
        height: auto;
        display: none;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);

        img {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      &:hover>.image {
        display: block;
      }
    }
  }
</style>